import { getAuthUser } from "src/services/Authentication/AuthenticationService";
import { AuthActionTypes, LOGIN, LOGOUT, LOCK, UNLOCK, REFRESH_TOKENS } from "./authActionTypes";

const initialState = getAuthUser();

const authReducer = (state = initialState, action: AuthActionTypes) => {
  switch (action.type) {
    case LOGIN:
      return { user: action.payload, logged: true, isLocked: false };

    case LOGOUT:
      return { user: null, logged: false, isLocked: false };

    case LOCK:
      return { ...state, isLocked: true };

    case UNLOCK:
      return { user: action.payload, logged: true, isLocked: false };

    case REFRESH_TOKENS:
      if (!state.user) return state;
      return { ...state, user: action.payload, isLocked: false };

    default:
      return state;
  }
};

export default authReducer;
